import React, {useEffect} from "react";
import Breadcrumb from "../Components/Breadcrumb";
import bgImg from '../Images/calculator-breadcrumb.webp'
import CalculatorSection from "../Components/CalculatorSection";
import Products from "../Components/Products";
import Application from "../Components/Application";
import Cta from "../Components/Cta";
import ApplicationTable from "../Components/ApplicationTable";

const Calculator=()=>{
    useEffect(() => {
            document.title =
              "Tile Adhesive Consumption Calculator | VigoFlex";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Estimate your tile adhesive requirement accurately. Enter your area and tile size to get instant material estimates. Save on costs with the VigoFlex Estimation tool."
              );
            }
        
             const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://vigoflex.in/calculator");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Tile Adhesive Consumption Calculator | VigoFlex"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Estimate your tile adhesive requirement accurately. Enter your area and tile size to get instant material estimates. Save on costs with the VigoFlex Estimation tool."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://vigoflex.in/calculator");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://vigoflex.in/files/calc-img.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Tile Adhesive Consumption Calculator | VigoFlex"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Estimate your tile adhesive requirement accurately. Enter your area and tile size to get instant material estimates. Save on costs with the VigoFlex Estimation tool."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://vigoflex.in/files/calc-img.webp"
            );
          }
          }, [])
    return(
        <>
         {/**BREADCRUMB */}
        <Breadcrumb
        title="Tile Adhesive Coverage Calculator"
        bgImage={bgImg}
      />

       {/**CALCULATOR SECTION */}
        <CalculatorSection />

         {/**PRODUCTS GRID */}
        <Products />

        {/**COMPARISON TABLE */}
        <ApplicationTable />

        {/**APPLICATIONS SECTION */}
        <Application />

        <div className="margin-div"></div>

        {/**CTA SECTION */}
        <Cta />
        </>
    )
}
export default Calculator;